package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Modifier6Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/Modifier6.md", mapOf("data-auto-animate-restart" to listOf(), "layout" to listOf("center"), "behaviors" to listOf("auto-progress-fragments")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("modifiers-are-a-fork") }) {
                FaCodeFork()
                org.jetbrains.compose.web.dom.Text(" Modifiers are a fork!")
            }
            Horizontal {
                dev.bitspittle.droidconSf24.components.widgets.Code("""Modifier
    .padding(20.px)
    .fillMaxWidth()
""", "kotlin <fragment,fade-down>")
                dev.bitspittle.droidconSf24.components.widgets.Code("""Modifier
    .fillMaxWidth()
    .padding(20.px)
""", "kotlin <fragment,fade-down>")
                dev.bitspittle.droidconSf24.components.widgets.Code("""Modifier
    .padding(20.px)
    .fillMaxWidth()
    .padding(20.px)
""", "kotlin <fragment,fade-down>")
            }
        }
    }
}
